import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { useState } from 'react';

interface KeyRevealDialogProps {
  open: boolean;
  title: string;
  apiKey: string;
  message?: string;
  onClose: () => void;
}

const DEFAULT_MESSAGE =
  'Copy this key now. It will not be shown again.';

export function KeyRevealDialog({
  open,
  title,
  apiKey,
  message = DEFAULT_MESSAGE,
  onClose,
}: KeyRevealDialogProps) {
  const [copied, setCopied] = useState(false);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" paragraph>
          {message}
        </Typography>
        <TextField
          fullWidth
          multiline
          value={apiKey}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={async () => {
                    await navigator.clipboard.writeText(apiKey);
                    setCopied(true);
                  }}
                  aria-label="Copy API key"
                >
                  <FileCopyIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {copied && (
          <Typography variant="caption" color="primary">
            Copied to clipboard
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}
